import {
  faEdit,
  faPlay,
  faRotateRight,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { ArticleStatus } from "./ProgressBadge";

interface StatusActionsProps {
  articleId: string;
  status: ArticleStatus;
  onRetry?: () => void;
  onGenerateNow?: () => void;
  onShowProgress?: () => void;
  className?: string;
}

export function StatusActions({
  articleId,
  status,
  onRetry,
  onGenerateNow,
  onShowProgress,
}: StatusActionsProps) {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/articles/${articleId}`);
  };

  const iconClassName =
    "h-4 w-4 cursor-pointer text-gray-600 hover:text-gray-800 transition-colors";

  // Show appropriate icon based on status
  if (status === "scheduled" && onGenerateNow) {
    return (
      <FontAwesomeIcon
        icon={faPlay}
        className={`${iconClassName} hover:text-green-600`}
        onClick={onGenerateNow}
        title="Generate Now"
      />
    );
  }

  if (status === "failed" && onRetry) {
    return (
      <FontAwesomeIcon
        icon={faRotateRight}
        className={`${iconClassName} hover:text-blue-600`}
        onClick={onRetry}
        title="Retry Generation"
      />
    );
  }

  if (status === "in_progress" && onShowProgress) {
    return (
      <FontAwesomeIcon
        icon={faEye}
        className={`${iconClassName} hover:text-blue-600`}
        onClick={onShowProgress}
        title="View Progress"
      />
    );
  }

  if (status === "draft" || status === "completed" || status === "published") {
    return (
      <FontAwesomeIcon
        icon={faEdit}
        className={`${iconClassName} hover:text-blue-600`}
        onClick={handleEdit}
        title="Edit Article"
      />
    );
  }

  // Return null if no action is available
  return null;
}

export default StatusActions;
